<template>
  <div class="app">
    <router-view />
  </div>
</template>
<script>
export default {
  metaInfo: {
    titleTemplate: "%s | 디버",
    htmlAttrs: {
      lang: "ko"
    },
    meta: [
      { name: "theme-color", content: "#2ea3ff" },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0"
      },
      {
        name: "description",
        content: "디버만의 Fit한 배송을 경험해 보세요."
      },
      {
        property: "og:title",
        content: "디버, 나에게 Fit한 배송"
      },
      {
        property: "og:type",
        content: "website"
      },
      {
        property: "og:description",
        content: "디버만의 Fit한 배송을 경험해 보세요."
      },
      {
        property: "og:site_name",
        content: "디버"
      },
      {
        property: "og:url",
        content: "https://dver.co.kr"
      },
      {
        property: "og:image",
        content: "https://dver.co.kr/images/dver_og_1200x630.png"
      },
      {
        property: "og:locale",
        content: "ko_KR"
      },
      {
        name: "twitter:card",
        content: "summary"
      },
      {
        name: "twitter:title",
        content: "디버, 나에게 Fit한 배송"
      },
      {
        name: "twitter:description",
        content: "디버만의 Fit한 배송을 경험해 보세요."
      },
      {
        name: "twitter:image",
        content: "https://dver.co.kr/images/dver_og_1200x630.png"
      }
    ]
  }
};
</script>
<style>
#app,
.app {
  background: #fff;
}

:root {
  --deep-blue: #0081ea;
  --aqua-blue: #2ea3ff;
  --sky-blue: #f5faff;
  --white: #ffffff;
  --gray-content: #4e5459;
  --gray-sub: #b7bec5;
  --gray-description: #7f868b;
  --black-0: #f6f8f9;
  --black-1: #ecf0f3;
  --black-2: #e3e7eb;
  --black-3: #d7dbde;
  --black-5: #969ea4;
  --black-8: #4e5459;
  --black-9: #212529;

  /**2.0 디자인 가이드 */
  --gray-100: #f7f9fb;
  --gray-200: #eff2f5;
  --gray-300: #d7dee7;
  --gray-400: #b3bfcb;
  --gray-500: #8593a3;
  --gray-600: #54606e;
  --gray-700: #282e33;

  --primary-100: #f0f9ff;
  --primary-200: #d5edfe;
  --primary-300: #83c8ff;
  --primary-400: #2ea3ff;
  --primary-500: #0077eb;
  --primary-600: #0059cd;

  --secondary-100: #f3f7ff;
  --secondary-200: #cbdcff;
  --secondary-300: #99baff;
  --secondary-400: #6698ff;

  --tertiary-100: #ccf5ff;
  --tertiary-200: #66e1ff;
  --tertiary-300: #00ccff;

  --red-100: #fff0f1;
  --red-200: #febdc2;
  --red-300: #fe8b93;
  --red-400: #fe4950;

  --yellow-100: #ffefc7;
  --yellow-200: #ffd361;
  --yellow-300: #fab400;
}
</style>
